<div class="mb-6 flex items-center justify-between">
  <h1 class="textTabsColor text-2xl font-bold" i18n="@@breadcrumbRoute">Routes</h1>
</div>

<app-route-filters
  [filters]="filters()"
  (toggleSortOrder)="toggleSortOrder()"
  (resetFilters)="resetFilters()"
  (applyFilters)="applyFilters($event)" />

<app-route-table
  [routes]="routes()"
  [state]="state()"
  [currentPage]="currentPage()"
  [totalItems]="totalItems()"
  [itemsPerPage]="itemsPerPage()"
  [totalPages]="totalPages"
  [isFiltersApplied]="isFiltersApplied()"
  (pageChange)="onPageChange($event)"
  (pageSizeChange)="onPageSizeChange($event)"
  (rowClick)="navigateToDetails($event)"
  (editRoute)="navigateToEdit($event)"
  (deleteRoute)="onDeleteRoute($event)"
  (toggleActive)="onToggleActive($event)" />
